import { render, staticRenderFns } from "./HeadingGroup.vue?vue&type=template&id=4c6f9244&scoped=true"
import script from "./HeadingGroup.vue?vue&type=script&lang=ts"
export * from "./HeadingGroup.vue?vue&type=script&lang=ts"
import style0 from "./HeadingGroup.vue?vue&type=style&index=0&id=4c6f9244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6f9244",
  null
  
)

export default component.exports